/**
 * @description 停賣範圍 (全部: A，部份: B)
 */
export enum TradeoffRange {
  /** 全部 */
  All = 'A',
  /** 部份 */
  Some = 'B'
}
